import * as React from 'react';
import {css, Icon, view} from '@sail/ui/deprecated';

import type {IconAsset} from '@sail/icons/types';
import {EligibleChannelsEndpointResponseChannel} from '../../../generated/types';

export type ChannelType = {
  title: React.ReactNode;
  type: EligibleChannelsEndpointResponseChannel['type'];
  icon: IconAsset;
  disabled: boolean;
  waitEstimate?: React.ReactNode;
  locale: string;
};

export const Channel = ({
  channel,
  onClick,
}: {
  channel: ChannelType;
  onClick: (arg1: React.MouseEvent) => void;
}): JSX.Element => {
  const {disabled, icon, type, title, waitEstimate} = channel;

  const primaryColor = disabled ? 'disabled' : 'primary';
  const secondaryColor = disabled ? 'disabled' : 'secondary';

  return (
    <view.button
      data-testid={`channel-button-${type}`}
      disabled={disabled}
      onClick={onClick}
      css={{
        background: 'surface',
        border: css.value('none'),
        textAlign: css.value('left'),
        width: 'fill',
      }}
    >
      <view.div
        css={{
          display: css.value('flex'),
          alignItems: css.value('center'),
          marginTop: css.value('12px'),
        }}
      >
        <Icon
          icon={icon}
          size="xsmall"
          css={{
            fill: secondaryColor,
            marginLeft: css.value('12px'),
            flexShrink: css.value('0'),
          }}
        />
        <view.h3
          css={{
            marginLeft: css.value('12px'),
            marginTop: 0,
            marginBottom: 0,
            color: primaryColor,
          }}
        >
          {title}
        </view.h3>
      </view.div>
      <view.p
        css={{
          marginLeft: css.value('36px'),
          marginTop: css.value('4px'),
          color: secondaryColor,
        }}
      >
        {waitEstimate}
      </view.p>
    </view.button>
  );
};
